import { backend } from 'services';

import { apiPaths } from './routes';

export function azureCodeRequest(code: string): Promise<{ accessToken: string }> {
  return backend.post(`${apiPaths.oauth}/azure`, { code });
}
